import Vue from 'vue'
import Router from 'vue-router'

const px_data = () => import("@/components/study/px_data");
const px_user = () => import("@/components/study/px_user");
const px_class = () => import("@/components/study/px_class");



Vue.use(Router)

//培训业务//////////////////////////
export default [

	{
		name: "px_data",
		path: "/px_data",
		component: px_data,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "培训资料设置"
		}
	},
	{
		name: "px_user",
		path: "/px_user",
		component: px_user,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "培训学习结果"
		}
	},
	{
		name: "px_class",
		path: "/px_class",
		component: px_class,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "培训分类"
		}
	}
]